
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/mapbox-tiling-service',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/mapbox-tiling-service/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/basic-recipe-using-zoom-levels/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-basic-recipe-using-zoom-levels" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_basic-recipe-using-zoom-levels.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/bathymetry/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-bathymetry" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_bathymetry.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/bbox/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-bbox" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_bbox.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/building-footprints/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-building-footprints" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_building-footprints.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/census-blocks/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-census-blocks" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_census-blocks.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/natural-earth-countries-and-polygon-simplification/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-natural-earth-countries-and-polygon-simplification" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_natural-earth-countries-and-polygon-simplification.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/natural-earth-data-populated-places/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-natural-earth-data-populated-places" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_natural-earth-data-populated-places.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/natural-earth-data-roads/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-natural-earth-data-roads" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_natural-earth-data-roads.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/points-of-interest/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-points-of-interest" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_points-of-interest.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/examples/union-road-features-based-on-common-attributes/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-examples-union-road-features-based-on-common-attributes" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_examples_union-road-features-based-on-common-attributes.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/errors/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-errors" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_errors.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/frequentlyaskedquestions/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-frequentlyaskedquestions" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_frequentlyaskedquestions.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-pricing" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_pricing.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/tileset-recipes/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-tileset-recipes" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_tileset-recipes.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/tileset-sources/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-tileset-sources" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_tileset-sources.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/guides/warnings/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-guides-warnings" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_guides_warnings.js'
            ),
            
            
          },{
            path: '/mapbox-tiling-service/reference/',
            getPage: () => import(
              /* webpackChunkName: "mapbox-tiling-service-reference" */
              '/work/mts-docs/_site_tmp/_mapbox-tiling-service_reference.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };